import { EhsListItem } from "./EhsListsManagement";
import { confirmDialog } from "@velocity-ehs/component-library";

export enum EhsConfigurationStatus {
  Active = "Active",
  Inactive = "Inactive",
}

export const EhsConfigurationOptions = Object.values(
  EhsConfigurationStatus
).map((value) => ({
  id: value,
  label: value,
}));

export interface EhsConfiguration {
  version: number;
  description: string;
  createdBy: {
    id: string;
  };
  dateTimeCreated: string;
  active: boolean;
  id: string;
  name: string;
  configurationType: {
    id: string;
    name: string;
  };
}

export function handleStatusChange(
  item: EhsListItem,
  onChange: Function,
  t: any
) {
  if (!item.enabled) {
    onChange(item);
    return;
  }
  confirmDialog({
    message: t("list_manager_confirm_inactivate_message"),
    header: t("list_manager_inactivate_header"),
    accept: () => onChange(item),
    reject: () => true,
    acceptLabel: t("universal_Inactivate"),
    rejectLabel: t("universal_Cancel"),
  });
}
